import { gql } from "@apollo/client";
import { apolloClient } from "../../services/apolloclient";

export const GET_PDF  = gql`
query MyQuery {
  menupage {
    menuFrontCover {
      urls
    }
    menuFrontCoverEnabled
    menuBackCover {
      urls
    }
    menuBackCoverEnabled
    pages {
      contentItems {
        ... on Page {
          menuImage {
            urls
          }
          enabled
        }
      }
    }
  }
}
`;
export async function fetchPdf() {
  const result = await apolloClient.query({
    query: GET_PDF,
    fetchPolicy: "network-only",
  });

  return result.data;
}
